import { PermissionKey, UserRole } from '../enums';

export interface AuthUser {
  id: string;
  email: string;
  role: UserRole;
  capabilities?: PermissionKey[];
}
